import { Injectable } from '@angular/core';
import {
    PpConditionConfig,
    PpHttpParams,
    PpHttpService,
} from '@penpencil/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorHandlerService } from '../error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionService extends ErrorHandlerService {
    private _permissions: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
        [],
    );
    constructor(private _ppHttpService: PpHttpService) {
        super();
    }

    setPermissions(value: string[], reset = false): void {
        if (value.length) {
            this._permissions.next(value);
        }
        if (reset) {
            this._permissions.next([]);
        }
    }

    getPermissions(): BehaviorSubject<any[]> {
        return this._permissions;
    }

    createCondition(permission: string): PpConditionConfig {
        return {
            type: 'group',
            group: {
                type: 'or',
                values: [
                    {
                        type: 'single',
                        match: {
                            operator: 'equals',
                            key: 'role',
                            value: 'Super Admin',
                        },
                    },
                    {
                        type: 'single',
                        match: {
                            operator: 'equals',
                            key: 'permission',
                            value: 'all',
                        },
                    },
                    {
                        type: 'single',
                        match: {
                            operator: 'includes',
                            key: 'permissions',
                            value: permission,
                        },
                    },
                ],
            },
        };
    }

    getRolesDetail(
        roleId: string,
        orgId: string,
        query: any = {},
    ): Observable<any> {
        return this._ppHttpService
            .get({
                apiPath: `v1/admin/roles/${roleId}/organization/${orgId}/permissions`,
                params: new PpHttpParams().appendAll(query),
            })
            .pipe(catchError(this.handleError));
    }

    getScopes(query?: any): Observable<any> {
        return this._ppHttpService
            .get({
                apiPath: 'v1/admin/scopes',
                params: new PpHttpParams().appendAll(query),
            })
            .pipe(catchError(this.handleError));
    }

    assignPermissionToRole(roleId: string, data: any): Observable<any> {
        return this._ppHttpService
            .put(data, {
                apiPath: `v1/admin/roles/${roleId}/assign-permission`,
            })
            .pipe(catchError(this.handleError));
    }
}
